(() => {
  const selector = '[data-valmonti-product-accordion]';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const timing = { duration: 280, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' };

  const init = (details) => {
    if (!details || details.dataset.valmontiAccordionReady) return;

    const summary = details.querySelector('summary');
    const content = details.querySelector('[data-valmonti-product-accordion-content]');
    if (!summary || !content) return;

    details.dataset.valmontiAccordionReady = 'true';
    let animation = null;

    const reset = () => {
      details.style.removeProperty('height');
      details.style.removeProperty('overflow');
      delete details.dataset.state;
      animation = null;
    };

    const cancelAnimation = () => {
      if (!animation) return;
      animation.onfinish = null;
      animation.cancel();
      animation = null;
    };

    const animate = (opening) => {
      const startHeight = details.getBoundingClientRect().height;
      cancelAnimation();

      if (reducedMotion.matches || typeof details.animate !== 'function') {
        details.open = opening;
        reset();
        return;
      }

      details.style.overflow = 'hidden';
      details.dataset.state = opening ? 'opening' : 'closing';

      let endHeight;
      if (opening) {
        details.open = true;
        endHeight = details.scrollHeight;
      } else {
        const styles = getComputedStyle(details);
        const borders = parseFloat(styles.borderTopWidth) + parseFloat(styles.borderBottomWidth);
        endHeight = summary.getBoundingClientRect().height + borders;
      }

      animation = details.animate(
        { height: [`${startHeight}px`, `${endHeight}px`] },
        timing,
      );
      animation.onfinish = () => {
        details.open = opening;
        reset();
      };
    };

    summary.addEventListener('click', (event) => {
      event.preventDefault();
      const opening = !details.open || details.dataset.state === 'closing';
      animate(opening);
    });
  };

  const observe = (scope = document) => scope.querySelectorAll(selector).forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => observe(), { once: true });
  } else {
    observe();
  }

  document.addEventListener('shopify:section:load', (event) => observe(event.target));
})();
